import React from 'react';
import { Badge } from '.';
import { useEssentials } from '../../contexts/essentials-context';
import { Box, Text } from '@wix/design-system';
import { DATE_LOCALE } from './language-to-locales';
import s from './badge-tooltip.module.scss';

interface DeveloperSaleBadgeProps {
  showBorder?: boolean;
  size?: 'tiny' | 'small' | 'medium';
  amount: string;
  endDate?: Date;
  languageCode?: string;
}

export function DeveloperSaleBadge({
  showBorder,
  size = 'small',
  amount,
  endDate,
  languageCode = 'en',
}: DeveloperSaleBadgeProps) {
  const { t, experiments } = useEssentials();

  const showNewDevSaleBadge =
    experiments?.enabled('specs.app-market.NewDevSaleBadge') ?? false;

  return (
    <Box marginTop="2px">
      <Badge
        skin="standard"
        type="outlined"
        dataHook="dev-sale-badge"
        uppercase={false}
        showBorder={showBorder}
        size={size}
        tooltipContent={
          <Text
            size="small"
            weight="thin"
            // @ts-expect-error wds types are incompatible
            skin="light"
            className={s.tooltipText}
          >
            {t('developer.sale.badge.tooltip', {
              amount,
              endDate: endDate
                ? new Date(endDate).toLocaleDateString(
                    DATE_LOCALE[languageCode],
                    {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      timeZone: 'UTC',
                    },
                  )
                : '',
            })}
          </Text>
        }
      >
        <Box marginTop="0px" color="#116DFF" fontSize="small">
          {showNewDevSaleBadge
            ? t('developer.sale.new.badge', { amount })
            : t('developer.sale.badge', { amount })}
        </Box>
      </Badge>
    </Box>
  );
}
